<template>
  <div id="app">
    <div class="hp-manager-header">
      <div class="hp-manager-header-logo">
        <router-link to='/'>
          <img src="../../assets/logo.png" style="width:100%" />
        </router-link>
      </div>
      <div class="hp-manager-tool">
        <div>
          <a-button type="primary" class="mybtn" @click="toggleCollapse" style="margin-top: 16px;margin-left:10px">
            <a-icon :type="isCollapse ? 'menu-unfold' : 'menu-fold'" />
          </a-button>
        </div>
        <hp-manager-headersearch></hp-manager-headersearch>
        <hp-header-user></hp-header-user>
      </div>

    </div>
    <div class="hp-manager-app">
      <div class="hp-manager-app-menu" :style="{width: isCollapse ? '80px' : '200px' ,height:'calc(100vh - 60px)' }">
        <hp-manager-menu :menusarr="menus" :collapsed="isCollapse"></hp-manager-menu>
      </div>
      <div class="hp-manager-app-container" :style="{marginLeft: isCollapse ? '80px' : '200px' }">
        <div class="hp-manager-header-breadcrumb">
          <hp-manager-breadcrumb></hp-manager-breadcrumb>
        </div>
        <div class="hp-manager-app-router">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../../config";
import { rejects } from "assert";
import account from "@/mixins/account";
export default {
  mixins: [account],
  name: "hp-manager-app",
  data() {
    return {
      isCollapse: false,
      menus: []
    };
  },
  mounted() {
    let Oldmenus = JSON.parse(sessionStorage.getItem("menus") || "[]");
    this.menus = Oldmenus;
  },
  methods: {
    logout() {
      this.$router.push({ name: "login" });
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    }
  }
};
</script>
<style lang="scss">
body {
  background-color: #f0f2f5 !important;
}
.hp-manager-header {
  position: fixed;
  top: 0;
  z-index: 10;
}
.hp-manager-app {
  margin-top: 60px;
}
.hp-manager-app-container {
  padding: 20px !important;
  background: #f0f2f5;
  height: auto !important;
}
.hp-manager-app-router {
  padding: 0px !important;
  border-radius: 5px;
  background: transparent !important;
  margin-top: 10px;
}
.hp-manager-header {
  padding-right: 40px;
}
.mybtn,
.mybtn:focus {
  background: transparent;
  border-color: transparent;
}
.hp-manager-app-menu {
  position: fixed;
  left: 0;
}
.hp-manager-app-menu::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.hp-manager-app-menu::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}
.hp-manager-app-menu::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
.hp-manager-page-list-filter {
  padding: 20px 0;
  background: #fff;
}
.hp-manager-page-list-filter .ant-btn {
  margin-right: 20px;
}
.hp-manager-page-list-filter::before {
  contain: "";
  clear: both;
}
.ant-table-wrapper {
  background: #fff;
  margin-top: 20px;
}
// .hp-manager-app-router {
//   padding: 0 !important;
// }
.ant-table-pagination.ant-pagination {
  margin-right: 20px;
}
.ant-table-thead > tr > th {
  background: #fff !important;
  background-clip: padding-box !important;
}
.hp-editor {
  line-height: normal !important;
}
@import "../../assets/scss/output.scss";
#app {
  display: flex;
  flex-direction: column;
  background: #2a303c;
}
.hp-manager-tool {
  flex: 1;
  display: flex;
  justify-content: space-between;
}
@include b(header) {
  display: flex;
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: #2a303c;
  box-sizing: border-box;
  padding: 0 20px 0 0;
  @include e(logo) {
    width: $menu-width;
    color: $--white;
    text-align: center;
  }
  @include e(breadcrumb) {
    height: 60px;
    padding: 0 20px;
  }

  @include e(logout) {
    position: absolute;
    top: 0;
    right: 20px;
    color: $--white;
    font-size: 14px;
    @include pseudo(hover) {
      color: $--primary-color;
    }
  }
}
@include b(app) {
  flex: 1;
  display: flex;
  width: 100%;
  @include e(menu) {
    height: 100%;
    background-color: #2a303c;
    overflow-x: hidden;
    overflow-y: auto;
    .el-menu {
      border: 0;
    }
  }
  @include e(menu-toggle) {
    line-height: 30px;
    font-size: 18px;
    color: $--white;
    text-align: center;
    cursor: pointer;
    background-color: #343a45;
    i {
      transform: rotate(-90deg);
    }
    &.active {
      i {
        transform: rotate(0deg);
      }
    }
  }
  @include e(container) {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    height: 100%;
  }
  @include e(router) {
    flex: 1;
    overflow-x: hidden;
    overflow-y: auto;
    background: $--body-background-color;
    padding: 0 20px 20px;
  }
}
</style>




// WEBPACK FOOTER //
// src/router/main/index.vue